export const getRefundChildIds = (passenger) => { var _a, _b; return (_b = (_a = passenger.children) === null || _a === void 0 ? void 0 : _a.map(child => child.id)) !== null && _b !== void 0 ? _b : []; };
const getFamilyLabel = (adult) => {
    var _a;
    const childrenNames = (_a = adult.children) === null || _a === void 0 ? void 0 : _a.map(child => child.values.fullName).filter(Boolean).join(', ');
    return childrenNames ? `${adult.values.fullName}, ${childrenNames}` : adult.values.fullName;
};
export const getRefundPassengerLabel = (passenger) => {
    var _a;
    if (passenger.type === 'ADT' && ((_a = passenger.children) === null || _a === void 0 ? void 0 : _a.length)) {
        return getFamilyLabel(passenger);
    }
    return passenger.values.fullName;
};
